import { NOT_FOUND } from 'redux-first-router';

const components = {
  HOME: 'ChooseDialog',
  FINISHED: 'Finished',
  MAP: 'DataAndMap',
  [NOT_FOUND]: 'NotFound',
};

export default (state = 'HOME', action = {}) => components[action.type] || state;



// WEBPACK FOOTER //
// ./src/reducers/page.js